module.exports = __webpack_public_path__ + "img/columbia-100-2x_58217d50209b9ae3a6d237bcf721f0b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/columbia-100-2x.jpg
// module id = 286
// module chunks = 0